import { createSlice } from "@reduxjs/toolkit";

const initialPlanUsageLogState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  planUsageLogForEdit: undefined,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const planUsageLogSlice = createSlice({
  name: "planUsageLog",
  initialState: initialPlanUsageLogState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getPlanUsageLogById
    planUsageLogFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.planUsageLogForEdit = action.payload.planUsageLogForEdit;
    },
    // findPlanUsageLog
    planUsageLogsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    planUsageLogReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
  },
});
